const addCartIconToPreviewBtn = () => {
  const previewAtcBtn = document.querySelector("#preview-teeAtcButton");
  if (!previewAtcBtn) return;
  if (previewAtcBtn.querySelector(".pfh-preview-atc-icon")) return;

  const iconMarkup = `<span class="pfh-preview-atc-icon" aria-hidden="true"><svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path d="M1.2 2.2H3.01c.25 0 .37 0 .47.05.09.04.16.1.21.18.06.09.08.21.11.46l.47 3.31M20.92 12.5l-.43 1.6c-.18.92-.27 1.38-.5 1.73-.21.31-.5.55-.84.7-.39.17-.86.17-1.8.17H8.79c-.99 0-1.49 0-1.88-.18-.35-.16-.65-.42-.85-.75-.23-.37-.29-.86-.43-1.84L4.27 6.2M4.27 6.2H11" stroke="#ffffff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><circle cx="8.97" cy="21.42" r="1.08" fill="#ffffff" stroke="#ffffff" stroke-width="1.8"/><circle cx="17.53" cy="21.42" r="1.08" fill="#ffffff" stroke="#ffffff" stroke-width="1.8"/><path d="M18.4 3.77v3.66M16.57 5.6h3.66" stroke="#ffffff" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="18.4" cy="5.6" r="5" stroke="#ffffff" stroke-width="1.2"/></svg></span>`;
  const textEl = previewAtcBtn.querySelector(".tee-btn__text");
  if (textEl) {
    textEl.insertAdjacentHTML("beforebegin", iconMarkup);
  } else {
    previewAtcBtn.insertAdjacentHTML("afterbegin", iconMarkup);
  }
};

const addTopContentToPreviewModal = () => {
  document.querySelectorAll(".tee-btn--preview").forEach((button) => {
    button.addEventListener("click", () => {
      addCartIconToPreviewBtn();
      const htmlToInsert = `<div class="modal_preview--modify_notice">
                                <p class="modal_preview--title">Please check the preview carefully</p>
                                <p class="modal_preview--notice_content">Make sure the customization is correct to receive your item faster</p>
                              </div>`;
      document
        .querySelector(".tee-dialog-gallery .tee-dcontent")
        .insertAdjacentHTML("beforebegin", htmlToInsert);
    });
  });
};

const checkCustomizationModal = () => {
  var hasCustomization = window.teeinblue.hasCustomization(
    window.TeeInBlueCampaign.productId
  );
  const modal = document.getElementById("reset_tib_customizations");

  if (modal && hasCustomization) {
    modal.style.display = "block";

    const closeButtons = document.querySelectorAll("[data-close-modal]");
    const resetButtons = document.querySelectorAll("[data-reset-modal]");
    const confirmButtons = document.querySelectorAll("[data-confirm-reset]");

    closeButtons.forEach((button) =>
      button.addEventListener("click", () => (modal.style.display = "none"))
    );

    resetButtons.forEach((button) =>
      button.addEventListener("click", () => {
        button.disabled = true;
        button.innerHTML =
          '<span class="tee-spinner tee-spinner--sm"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 128 128" class="tee-icon-loading tee-icon-loading--sm"><g><path d="M64 127.75A63.76 63.76 0 0152.8 1.23v14.23a49.8 49.8 0 1022.4 0V1.23A63.76 63.76 0 0164 127.75z"></path><animateTransform attributeName="transform" type="rotate" from="0 64 64" to="360 64 64" dur="1260ms" repeatCount="indefinite"></animateTransform></g></svg></span>';
        window.teeinblue.resetCustomization(window.TeeInBlueCampaign.productId);
        modal.style.display = "none";
      })
    );

    confirmButtons.forEach((button) =>
      button.addEventListener("click", () => {
        button.disabled = true;
        button.innerHTML =
          '<span class="tee-spinner tee-spinner--sm"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 128 128" class="tee-icon-loading tee-icon-loading--sm"><g><path d="M64 127.75A63.76 63.76 0 0152.8 1.23v14.23a49.8 49.8 0 1022.4 0V1.23A63.76 63.76 0 0164 127.75z"></path><animateTransform attributeName="transform" type="rotate" from="0 64 64" to="360 64 64" dur="1260ms" repeatCount="indefinite"></animateTransform></g></svg></span>';
        window.teeinblue.refillCustomization(
          window.TeeInBlueCampaign.productId
        );
        setTimeout(() => {
          modal.style.display = "none";
        }, 500);
      })
    );
  }
};

document.addEventListener("teeinblue-event-component-injected", () => {
  // This section was previously used to handle the movement of the product price element
  // to a new location within the product block. The logic ensured that the price element
  // was moved to the top of the target element if both elements were present in the DOM.
  // before it was moved above the shipping info, now it is moved above the price element
  const elementToMove = document.querySelector(".tee-product-price");
  const targetElement = document.querySelector(".product-block--price");
  if (elementToMove && targetElement) targetElement.prepend(elementToMove);
  addTopContentToPreviewModal();
  checkCustomizationModal();
});

document.addEventListener("DOMContentLoaded", () => {
  const elementToMove2 = document.querySelector("#loading_element");
  const insertAfterElement2 = document.querySelector(
    "form.shopify-product-form"
  );
  if (elementToMove2 && insertAfterElement2)
    insertAfterElement2.before(elementToMove2);
});

/* [Product page][SP] Hien thi button Preview khi scroll tren mobile - click vao mo popup Preview - START */
const btnPreviewOnScroll = () => {
  // window.onscroll = function () {
  //   var stickyPreviewBtns = $(".pfh-customily-preview-button");
  //   var teeFormAction = document.querySelector("#teeFormActions");

  //   if (!teeFormAction) return;

  //   var stickyButton = document.querySelector(".pfh-clone-preview-btn");
  //   if (!stickyButton) return;

  //   // Get teeFormAction position relative to document
  //   var teeFormActionRect = teeFormAction.getBoundingClientRect();
  //   var teeFormActionTop = teeFormActionRect.top + window.scrollY;

  //   // Check if user has scrolled and is below teeFormAction
  //   var hasScrolled = window.scrollY > 50; // Small threshold to avoid showing on tiny scrolls
  //   var isBelowTeeFormAction = window.scrollY > teeFormActionTop;

  //   if (hasScrolled && isBelowTeeFormAction) {
  //     // Show sticky button
  //     stickyPreviewBtns.css("opacity", "1");
  //     stickyPreviewBtns.css("visibility", "visible");
  //     stickyButton.parentElement.style.backgroundColor = "#fff";
  //     stickyButton.style.setProperty(
  //       "-webkit-text-fill-color",
  //       "#fff",
  //       "important"
  //     );
  //     stickyButton.style.setProperty("border-color", "#f4993d ", "important");
  //   } else {
  //     // Hide sticky button
  //     stickyPreviewBtns.css("opacity", "0");
  //     stickyPreviewBtns.css("visibility", "hidden");
  //   }
  // };

  

  var stickyPreviewBtns = $(".pfh-customily-preview-button");
  var stickyButton = document.querySelector(".pfh-clone-preview-btn");
  if (!stickyButton) return;

  // Always show sticky preview button by default on load.
  stickyPreviewBtns.css("opacity", "1");
  stickyPreviewBtns.css("visibility", "visible");
  stickyButton.parentElement.style.backgroundColor = "#fff";
  stickyButton.style.setProperty("-webkit-text-fill-color", "#fff", "important");
  stickyButton.style.setProperty("border-color", "#f4993d ", "important");
};

const createPreviewBtn = () => {
  var btnPreview = `<div class="show-mobile-only-sticky-button pfh-customily-preview-button"> <button type="button" class="customily-preview-button ld-over-inverse pfh-clone-preview-btn" data-label="Add to cart" id="customily-preview-button"> <div class="ld ld-cycle ld-ring"></div>Preview your personalization</button></div>`;
  document
    .querySelector(".tee-form-wrapper")
    .insertAdjacentHTML("beforebegin", btnPreview);
};

const triggerClickPreviewBtn = () => {
  var stickyPreviewBtn = document.querySelector(
    ".pfh-customily-preview-button"
  );
  var previewBtn = document.querySelector(".tee-form-action .tee-btn--preview");
  if (stickyPreviewBtn && previewBtn) {
    stickyPreviewBtn.addEventListener("click", () => {
      var confirmedInput = document.querySelector('input[name="confirmed"]');
      if (confirmedInput) {
        previewBtn.click();
        if (!confirmedInput.checked) {
          confirmedInput.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          setTimeout(() => {
            addCartIconToPreviewBtn();
            const htmlToInsert = `<div class="modal_preview--modify_notice">
                    <p class="modal_preview--title">Please check the preview carefully</p>
                    <p class="modal_preview--notice_content">Make sure the customization is correct to receive your item faster</p>
                  </div>`;
            document
              .querySelector(".tee-dialog-gallery .tee-dcontent")
              ?.insertAdjacentHTML("beforebegin", htmlToInsert);
          }, 50);
        }
      } else {
        previewBtn.click();
        setTimeout(() => {
          addCartIconToPreviewBtn();
          const htmlToInsert = `<div class="modal_preview--modify_notice">
                  <p class="modal_preview--title">Please check the preview carefully</p>
                  <p class="modal_preview--notice_content">Make sure the customization is correct to receive your item faster</p>
                </div>`;
          document
            .querySelector(".tee-dialog-gallery .tee-dcontent")
            ?.insertAdjacentHTML("beforebegin", htmlToInsert);
        }, 50);
      }
    });
  }
};

document.addEventListener("teeinblue-event-component-injected", () => {
  createPreviewBtn();
  btnPreviewOnScroll();
  triggerClickPreviewBtn();
});
/* [Product page][SP] Hien thi button Preview khi scroll tren mobile - click vao mo popup Preview - END */

// Thay description content
const replaceDescContent = () => {
  if (!window.TIBOverrideDesc) return;

  setTimeout(() => {
    const teeDescriptionContent = document.querySelector(
      ".tee-description__content"
    );
    const targetDiv = document.querySelector(
      '.product-tabs__panel[tabindex="0"] .rte'
    );
    if (teeDescriptionContent && targetDiv) {
      targetDiv.innerHTML = teeDescriptionContent.innerHTML;
    }
  }, 300);
};

document.addEventListener("teeinblue-event-component-injected", () => {
  replaceDescContent();
});

document.addEventListener("teeinblue-event-variant-changed", () => {
  replaceDescContent();
});

// /* [Product Page] Add KiwiSizing element */

/* [Product Page] KiwiSizingChart - START */
// const checkKiwiSizingChart = () => {
//   var kiwiSizingChart = document.querySelector('#KiwiSizingChart .ks-chart-modal-link');
//   var teeOptionTitle = document.querySelector('.tee-option--size .tee-option__title');
//   if(kiwiSizingChart && teeOptionTitle) {
//     var existingClone = teeOptionTitle.querySelector('.ks-chart-modal-link');
//     if(!existingClone) {
//       var kiwiSizingChartClone = kiwiSizingChart.cloneNode(true);
//       teeOptionTitle.appendChild(kiwiSizingChartClone);
//       kiwiSizingChartClone.addEventListener('click', function() { kiwiSizingChart.click() });
//     }
//   }
// }
const checkKiwiSizingChart = () => {
  try {
    var kiwiSizingChart = document.querySelector(
      "#KiwiSizingChart .ks-chart-modal-link"
    );
    var sizeOptionEl = document.querySelector(
      ".tee-option--size .tee-option__title"
    );
    var productFormInitEl = document.querySelector(".product_form_options");
    var productInfo = null;
    var tags = null;
    var needCheckTags = ["Bulk_size", "couple beach shorts"];
    var needSpecialPlacing = false;
    if (productFormInitEl) {
      // productInfo is data-product in productFormInitEl
      productInfo = productFormInitEl.getAttribute("data-product");
      productInfo = JSON.parse(productInfo);
      tags = productInfo.tags;
      // check if any of the tags is in needCheckTags
      needSpecialPlacing = needCheckTags.some((tag) => tags.includes(tag));

      if (needSpecialPlacing) {
        needSpecialPlacing = true;
      }
    }

    if (kiwiSizingChart && sizeOptionEl) {
      if (needSpecialPlacing) {
        console.log({ needSpecialPlacing });
        var kiwiSizingChartClone = kiwiSizingChart.cloneNode(true);
        var atcForm = document.querySelector('form[action="/cart/add"]');
        atcForm.insertBefore(kiwiSizingChartClone, atcForm.firstChild);
        kiwiSizingChartClone.addEventListener("click", function () {
          kiwiSizingChart.click();
        });
      } else {
        var existingClone = sizeOptionEl.querySelector(".ks-chart-modal-link");
        if (!existingClone) {
          var kiwiSizingChartClone = kiwiSizingChart.cloneNode(true);
          sizeOptionEl.appendChild(kiwiSizingChartClone);
          kiwiSizingChartClone.addEventListener("click", function () {
            kiwiSizingChart.click();
          });
        }
      }
    }
  } catch (error) {
    console.error(error);
  }
};
document.addEventListener(
  "teeinblue-event-variant-changed",
  checkKiwiSizingChart
);
document.addEventListener("teeinblue-event-component-injected", () => {
  const checkElementRendered = setInterval(() => {
    if (document.querySelector("#KiwiSizingChart .ks-chart-modal-link")) {
      checkKiwiSizingChart();
      clearInterval(checkElementRendered);
    }
  }, 1000);
  document
    .querySelectorAll(".tee-available-products .tee-radio")
    .forEach((radio) => {
      radio.addEventListener("click", () => {
        setTimeout(() => {
          checkKiwiSizingChart();
        }, 200);
      });
    });
});
/* [Product Page] KiwiSizingChart - END */

// Put grouping product before TIB - START
document.addEventListener("teeinblue-event-component-injected", function () {
  const referenceProducts = document.querySelector(
    ".reference__products--wrapper"
  );
  const teeArtworkForm = document.querySelector("#tee-artwork-form");
  if (referenceProducts && teeArtworkForm) {
    teeArtworkForm.before(referenceProducts);
  }
});


// add custom properties to item when ATC
document.addEventListener("teeinblue-event-component-injected", () => {
  window.teeinblue.transformBeforeAddToCart = (input) => {
    return new Promise((resolve) => {
      const variantId = input.id;
      const randomPart = crypto.randomUUID
        ? crypto.randomUUID().replace(/-/g, "")
        : Math.random().toString(36).substring(2, 18);
      const cartItemKey = `${variantId}:${randomPart}`;

      const mergedProperties = {
        ...(input.properties || {}),
        _cart_item_key: cartItemKey,
      };

      const priorityPrefixes = ["_customization_", "_tib_design_link"];

      const prioritized = {};
      const others = {};

      for (const key in mergedProperties) {
        if (priorityPrefixes.some((prefix) => key.startsWith(prefix))) {
          prioritized[key] = mergedProperties[key];
        } else {
          others[key] = mergedProperties[key];
        }
      }

      input.properties = {
        ...prioritized,
        ...others,
      };

      resolve(input);
    });
  };
});


// hide live preview when click ATC and there's required fields not yet filled.
document.addEventListener('teeinblue-event-component-injected', (e) => {
  /* ===============================
  * CONFIG
  * =============================== */
  const INVALID_CLASS = 'tee-field--invalid';
  const CUSTOM_INVALID_CLASS = 'tee-field--invalid-custom';
  const TIB_FORM_SELECTOR = '.tee-customization-form';
  const CHECK_DELAY = 50;
  const CUSTOM_TIMEOUT = window.scroll_timeout ?? 500;
  const SAFE_GAP = 0;
  const STYLE_ID = 'tee-invalid-custom-style';
  /* ===============================
  * STYLE INJECT
  * =============================== */
  (function injectInvalidCustomStyle() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .tee-field--invalid-custom .tee-required-message {
        display: inline-block;
      }
    `;
    document.head.appendChild(style);
  })();
  /* ===============================
  * HELPER
  * =============================== */
  function getStickyGalleryHeight() {
    const sticky = document.querySelector('.gallery--sticky:not(.gallery--sticky--hide) .tee-gallery-content');
    if (sticky) return sticky.offsetHeight || 0;
    const base = document.querySelector('.tee-gallery-content');
    return base ? base.offsetHeight * 0.65 : 0;
  }
  /* ===============================
  * SCROLL
  * =============================== */
  function scrollToInvalidPredict(el) {
    if (!el) return;
    const rect = el.getBoundingClientRect();
    let baseOffset = window.teeinblue.requiredScrollOffset ?? -50;
    const galleryHeight = getStickyGalleryHeight();
    const finalTop = rect.top + window.pageYOffset + baseOffset - galleryHeight - SAFE_GAP;
    window.scroll({ top: finalTop, left: 0, behavior: 'smooth' });
  }
  /* ===============================
  * CORE HANDLER
  * =============================== */
  function checkAndScrollInvalid() {
    if (document.body.classList.contains('vm--block-scroll')) return;
    const container = document.querySelector(TIB_FORM_SELECTOR) || document.body;
    const invalidEls = Array.from(container.querySelectorAll(`.${INVALID_CLASS}, .${CUSTOM_INVALID_CLASS}`));
    if (!invalidEls.length) return;
    invalidEls.forEach(el => {
      if (el.classList.contains(INVALID_CLASS)) {
        el.classList.add(CUSTOM_INVALID_CLASS);
        el.classList.remove(INVALID_CLASS);
      }
    });
    invalidEls.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);
    setTimeout(() => {
      scrollToInvalidPredict(invalidEls[0]);
    }, CUSTOM_TIMEOUT);
  }
  /* ===============================
  * TRIGGER
  * =============================== */
  if (window.innerWidth < 750) {
    document.addEventListener('click', e => {
      const trigger = e.target.closest('.tee-btn--atc,.tee-btn--preview,.customily-preview-button');
      if (!trigger) return;
      setTimeout(checkAndScrollInvalid, CHECK_DELAY);
    }, true);
  }
});

// hide single preview option
function hideSinglePreviewOptions(root = document) {
  const options = root.querySelectorAll('.tee-variants .tee-option');
  options.forEach(option => {
    const radios = option.querySelectorAll('.tee-radio');
    option.style.display = '';
    radios.forEach(radio => (radio.style.display = ''));
    if (!radios.length) return;
  // case option chỉ có 1 variant thì sẽ luôn ẩn cả block option 
    if (radios.length === 1) {
      const text = radios[0].querySelector('span')?.textContent?.trim();
      if (text === 'As Preview' || text === 'As Described') {
        option.style.display = 'none';
      }
      return;
    }
  // case có nhiều variant thì chỉ ẩn 1 variant As Preview/As Described 
    radios.forEach(radio => {
      const text = radio.querySelector('span')?.textContent?.trim();
      if (text === 'As Preview' || text === 'As Described') {
        radio.style.display = 'none';
      }
    });
  });
}
document.addEventListener('teeinblue-event-component-injected', function () {
  hideSinglePreviewOptions();
});
document.addEventListener('teeinblue-event-after-cart-added', function () {
  hideSinglePreviewOptions();
});

document.addEventListener('teeinblue-event-variant-changed', function () {
  setTimeout(function() {
      hideSinglePreviewOptions();
  }, 50)
});

// Put grouping product before TIB - END

/* [Product Page] Gallery Custom - START */

/* update 04042024 */
/*

initGallery = (flkty) => {
  var currentIndex = $('.tee-thumbnail--active').index('.tee-thumbnail');
  flkty.select(currentIndex)
  
  let prevButton = document.querySelector('.tee-slider__button--prev');
  let nextButton = document.querySelector('.tee-slider__button--next');

  let oldX = 0;

  $('.tee-slider__track').on('dragStart.flickity', (event, { pageX }) => oldX = pageX);
  
  $('.tee-slider__track').on('dragEnd.flickity', (event, { pageX }) => {
      const diff = pageX - oldX;
      const button = diff < 0 ? nextButton : prevButton;
      if (button) button.click();
  });

  $('.flickity-prev-next-button.previous').on("click", (event) => {
      if(prevButton) {
        prevButton.click();
      }
  })
  $('.flickity-prev-next-button.next').on("click", (event) => {
      if(nextButton) {
        nextButton.click(); 
      }
  })

  handleThumbnailButtonClick = (event) => {
    var currentIndex = $('.tee-thumbnail--active').index('.tee-thumbnail');
    if(flkty.selectedIndex != currentIndex) {
      flkty.select(currentIndex);
    }
  }
  
  handleInputChange = (event) => {
    // $('.tee-field--clipart .tee-clipart-label').on("click", handleInputChange);
    // $('.tee-custom-select-item').on("click", handleInputChange);
    var currentIndex = $('.tee-thumbnail--active').index('.tee-thumbnail');
    if(flkty.selectedIndex != currentIndex) {
      flkty.select(currentIndex);
    }
  }
  
  $('.tee-thumbnails__button--prev').on("click", handleThumbnailButtonClick);
  $('.tee-thumbnails__button--next').on("click", handleThumbnailButtonClick);
  $('.tee-field--clipart .tee-clipart-label').on("click", handleInputChange);
  $('.tee-custom-select-item').on("click", handleInputChange);
  $('#teeFormInputs').on('input change', 'input[type="text"], input[type="checkbox"], input[type="radio"], select', handleInputChange);
}

document.addEventListener('teeinblue-event-component-injected', () => {
  const checkElementRendered = setInterval(() => {
    var teeSlider = document.querySelector('.product__images .tee-gallery-content .tee-slider__track');
    if (teeSlider) {
        if (!teeSlider.classList.contains('flickity-enabled')) {
        var flkty = new Flickity(teeSlider, {
          wrapAround: true,
          adaptiveHeight: true,
          dragThreshold: 10,
          imagesLoaded: true,
          pageDots: false,
          watchCSS: false,
        });
        
        $('.tee-thumbnail').on("click", (event) => {
          const index = $(event.currentTarget).index();
          flkty.select(index)
        });
        
        initGallery(flkty);
      };
      clearInterval(checkElementRendered);
    } else {
      console.log('Waiting for #tee-gallery to render...');
    }
  }, 1000);
})


document.addEventListener('teeinblue-event-variant-changed', () => {
  // var teeSlider = document.querySelector('.product__images .tee-gallery-content .tee-slider__track');
  // $('.product__images .tee-gallery-content .tee-slider__track').flickity().flickity('destroy');
  
  setTimeout(()=> {
    var teeSlider = document.querySelector('.product__images .tee-gallery-content .tee-slider__track');
    if (!teeSlider) return;

    var flkty = new Flickity(teeSlider, {
      wrapAround: true,
      adaptiveHeight: true,
      dragThreshold: 10,
      imagesLoaded: true,
      pageDots: false,
      watchCSS: false,
    });
    
    $('.tee-thumbnail').on("click", (event) => {
      const index = $(event.currentTarget).index();
      flkty.select(index)
    });
    
    var currentIndex = $('.tee-thumbnail--active').index('.tee-thumbnail');
    flkty.select(currentIndex)
    initGallery(flkty);
    
  }, 500)
})
*/

/* [Product Page] Gallery Draggable - END */
